import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import AutoComplete from "components/Custom/AutoComplete";
import { COMMON_JS } from "common/scripts";
import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { ERRORS, LABELS, SUB_TITLES, SUCCESS, TITLES } from "common/lables";

import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { PRODUCT_APIs } from "apihandlers/product";

const StockLevel = (props: any) => {
  const { setDashMenu } = props;

  const customerTypeRef: any = useRef(null);
  const salesRef: any = useRef(null);
  const productRef: any = useRef(null);
  const regionRef: any = useRef(null);
  const stateRef: any = useRef(null);
  const countryRef: any = useRef(null);

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [customerTypes, setCustomerTypes] = useState<any>(null);
  const [saleTypes, setSaleTypes] = useState<any>(null);
  const [products, setProducts] = useState<any>(null);
  const [regions, setRegions] = useState<any>(null);
  const [states, setStates] = useState<any>(null);
  const [countries, setCountries] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [columns, setColumns] = useState<any>([
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "organizationName",
      name: LABELS.ORG_NAME,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "organizationAddress1",
      name: LABELS.ORG_ADDRESS1,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "organizationAddress2",
      name: LABELS.ORG_ADDRESS2,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "organizationPinCode",
      name: LABELS.ORG_PIN,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "organizationMobile",
      name: LABELS.ORG_MOBILE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.AREA,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ]);

  useEffect(() => {
    if (loading) {
      getCustomerType();
      // getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getStockLevels(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getOrgProfiles:", error);
    }
  };

  const getCustomerType = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    CUSTOMER_APIs.getCustomerTypes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setCustomerTypes(list);
        getSalesType();
      }
    });
  };
  const getSalesType = () => {
    const args = {
      minResponse: true,
    };
    CUSTOMER_APIs.getCustSalesTypes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.salesType,
          };
        });
        setSaleTypes(list);
        getProducts();
      }
    });
  };

  const getProducts = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setProducts(list);
        getRegion();
      }
    });
  };
  const getRegion = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getRegions(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.regionName,
          };
        });
        setRegions(list);
        getState();
      }
    });
  };

  const getState = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        setStates(list);
        getCountry();
      }
    });
  };

  const getCountry = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getCountries(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.countryName,
          };
        });
        setCountries(list);
        getRows();
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const mangeCountry = () => {
    const organizationName = (
      document.getElementById("organizationName") as HTMLInputElement
    ).value.trim();
    const organizationAddress1 = (
      document.getElementById("organizationAddress1") as HTMLInputElement
    ).value.trim();
    const organizationAddress2 = (
      document.getElementById("organizationAddress2") as HTMLInputElement
    ).value.trim();
    const organizationPinCode = (
      document.getElementById("organizationPinCode") as HTMLInputElement
    ).value.trim();
    const organizationMobile = (
      document.getElementById("organizationMobile") as HTMLInputElement
    ).value.trim();
    const organizationEmail = (
      document.getElementById("organizationEmail") as HTMLInputElement
    ).value.trim();
    const organizationGst = (
      document.getElementById("organizationGst") as HTMLInputElement
    ).value.trim();
    const organizationPan = (
      document.getElementById("organizationPan") as HTMLInputElement
    ).value.trim();
    //const areaId = areaRef.current.selectedValue.id;
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    // Validations
    // let errors = [];
    // if (organizationName == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ORG_NAME +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (organizationAddress1 == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ORG_ADDRESS1 +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (organizationAddress2 == "") {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ORG_ADDRESS2 +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (organizationPinCode == "") {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ORG_PIN +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (organizationMobile == "") {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ORG_MOBILE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (!areaId) {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.AREA +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,
      organizationName,
      organizationAddress1,
      organizationAddress2,
      organizationPinCode,
      organizationMobile,
      organizationEmail,
      organizationGst,
      organizationPan,
      // areaId,
      activeStatus: activeStatus.toString(),
    };

    setIsSubmit(true);
    CUSTOMER_APIs.manageStockLevel(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.STOCK_LEVEL}</li>
        </ul>
        <h4>{TITLES.STOCK_LEVEL}</h4>
        <p>{SUB_TITLES.STOCK_LEVEL}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.STOCK_LEVEL}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.STOCK_LEVEL}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " +
                TITLES.ORGANIZATION_PROFILE +
                ": " +
                selectedRow.organizationName
              : "Add " + TITLES.ORGANIZATION_PROFILE
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="flexRowJustify">
              <div className="formGroup red width30">
                <label>
                  {LABELS.CUSTOMER_TYPE}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={customerTypes}
                  childRef={customerTypeRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30">
                <label>
                  {LABELS.SALES_TYPE}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={saleTypes}
                  childRef={salesRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30">
                <label>
                  {LABELS.PRODUCT}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={products}
                  childRef={productRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
            </div>
            <div className="flexRowJustify">
              <div className="formGroup red width30">
                <label>
                  {LABELS.REGION}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={regions}
                  childRef={regionRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30">
                <label>
                  {LABELS.STATE}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={states}
                  childRef={stateRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30">
                <label>
                  {LABELS.AREA}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete
                  list={countries}
                  childRef={countryRef}
                  defaultValue={
                    selectedRow.areaId
                      ? {
                          id: selectedRow.areaId,
                          label: selectedRow.areaName,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
            </div>
            <div className="flexRowJustify">
              <div className="formGroup red width30">
                <TxtRow
                  id={"organizationName"}
                  label={LABELS.ORG_NAME}
                  defaultValue={
                    selectedRow.id ? selectedRow.organizationName : ""
                  }
                  type={"text"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30">
                <TxtRow
                  id={"organizationAddress1"}
                  label={LABELS.ORG_ADDRESS1}
                  defaultValue={
                    selectedRow.id ? selectedRow.organizationAddress1 : ""
                  }
                  type={"text"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup red width30"></div>
            </div>
            <div className="formGroup ">
              <label>{LABELS.ACTIVE_STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>

            {/* mandatoryResults */}
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={mangeCountry}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(StockLevel);
